module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_lp/mainvisual-confetti-pc_56798506e899ddf51819bd7839f0f512.svg";